import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./component.css";

const WelcomeBanner = () => {
  const navigate = useNavigate();
  const handleStart = () => {
    navigate("/homepage"); // Navigate to homepage ("/")
  };

  const backgroundImageStyle = {
    backgroundImage: `url('/image/food2.png')`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    height: "100vh",
    position: "relative",

    overflow: "hidden",
  };

  return (
    <div style={backgroundImageStyle}>
      <div className="welcome-banner-overlay" />

      <div className="welcome-banner-content">
        <h2 className="welcome-heading">
          <span className="text-white">Welcome to</span> <br />
          <span className="text-white">
            Foodies! <span className="wave">👋</span>
          </span>
        </h2>

        <p className="welcome-description">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua
        </p>
        <button className="get-started-btn" onClick={handleStart}>
          Get Started...! <FaArrowRight />
        </button>
      </div>
    </div>
  );
};

export default WelcomeBanner;
